// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_9e1425b4d3--tooltip--gA5q6","arrow_tooltip":"_9e1425b4d3--arrow_tooltip--HT0YK","arrow":"_9e1425b4d3--arrow--nMIiS"};